import { inject, singleton } from "tsyringe";
import { ExtensionContext } from "../../common/models/extension-config";
import { Module } from "../../common/module";
import { Snippets } from "../../common/snippets";
import { CommonModule } from "../common.module";
import { ApiModule } from "../common/api/api.module";
import { type ButtonInfo, DashboardTooltipButtonManagerModule, type UrlData } from "../common/dashboard-tooltip-button-manager/dashboard-tooltip-button-manager.module";
import { ChangeRoleCommonModule } from "./changerole-common.module";
@singleton()
export class ChangeRoleToolbarButtonModule extends Module {
    public name: string = 'ChangeRoleToolbarButtonModule';
    public acceptedLicenseFlags: string[] = ['ChangeRole',  'NetflixIntegrations'];
    public shouldRun(context: ExtensionContext): boolean {
        return context === ExtensionContext.vizql;
    }
    constructor(
        @inject(CommonModule) private common: CommonModule,
        @inject(ChangeRoleCommonModule) private changeRoleCommon: ChangeRoleCommonModule,
        @inject(ApiModule) private apiModule: ApiModule,
        @inject(DashboardTooltipButtonManagerModule) private dashboardTooltipManager: DashboardTooltipButtonManagerModule) {
        super([common, changeRoleCommon, apiModule, dashboardTooltipManager]);
    }
    public async run(): Promise<void> {
        let btnManagerSub: number | undefined;
        this.changeRoleCommon.configEvent.subscribe(config => {
            if (btnManagerSub !== undefined) {
                this.dashboardTooltipManager.unRegisterButtonFn(btnManagerSub);
            }
            if (!config || !config.availableRoles?.length || !config.currentRole || (config.availableRoles.length === 1 && config.availableRoles[0] === config.currentRole)) {
                return;
            }
            btnManagerSub = this.dashboardTooltipManager.registerButtonFn(async (urlData: UrlData) => {
                const name = config.currentRole! as string;
                let normalizedName = "";
                for (let i = 0; i < name.length; i++) {
                    if (name[i] === name[i].toUpperCase() && i != 0) {
                        normalizedName += ' '
                    }
                    if (i === 0) {
                        normalizedName += name[i].toUpperCase();
                    } else {
                        normalizedName += name[i];
                    }
                }
                return {
                    disabled: false,
                    text: `Role: ${normalizedName}`,
                    svgXml: `<svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' width='16' height='16' fill='currentColor' class='bi bi-lock' viewBox='0 0 16 16'><path d='M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z'/></svg>`, 
                    svgMarginTop: 2,
                    svgTransformOrigin: 'left top',
                    svgTransform: 'scaleX(1.5) scaleY(1)',
                    onClicked: () => this.buttonClick()
                } as ButtonInfo;
            });
        });
    }

    private async buttonClick() {
        try {
            await this.changeRoleCommon.showDialog();
        } catch (e) {
            this.log.e('Failed to show change role dialog', e);
            alert('Failed to open Change role dialog');
        }
    }
}